import { createContext } from 'react';
import { CONTEXT, type PlpType } from '../data/constants';
import { type QueryParamState, type QueryParamReducer, usePlpQueryParams } from '../hooks';

export const PlpContext = createContext<{
  state: QueryParamState;
  dispatch: React.Dispatch<QueryParamReducer>;
} | null>(null);
PlpContext.displayName = CONTEXT.PLP_CONTEXT;

type PlpProviderProps = {
  children?: React.ReactNode;
  plpType: PlpType;
};

export const PlpProvider: React.FC<PlpProviderProps> = ({ children, plpType }) => {
  const { state, dispatch } = usePlpQueryParams({ plpType });

  return <PlpContext.Provider value={{ state, dispatch }}>{children}</PlpContext.Provider>;
};

export default PlpProvider;
